export default class MimeTypeHelper {
    public static getMimeTypeFromFileName = (fileName: string): string => {
        const extension = fileName.split('.').pop()?.toLowerCase();

        switch (extension) {
            // Documents
            case 'pdf': return 'application/pdf';
            case 'doc': return 'application/msword';
            case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'xls': return 'application/vnd.ms-excel';
            case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'ppt': return 'application/vnd.ms-powerpoint';
            case 'pptx': return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            case 'txt': return 'text/plain';
            case 'csv': return 'text/csv';
            case 'rtf': return 'application/rtf';
            case 'odt': return 'application/vnd.oasis.opendocument.text';

            // Images
            case 'jpg':
            case 'jpeg': return 'image/jpeg';
            case 'png': return 'image/png';
            case 'gif': return 'image/gif';
            case 'bmp': return 'image/bmp';
            case 'webp': return 'image/webp';
            case 'svg': return 'image/svg+xml';
            case 'tiff':
            case 'tif': return 'image/tiff';

            // Audio
            case 'mp3': return 'audio/mpeg';
            case 'wav': return 'audio/wav';
            case 'ogg': return 'audio/ogg';
            case 'm4a': return 'audio/mp4';

            // Video
            case 'mp4': return 'video/mp4';
            case 'mov': return 'video/quicktime';
            case 'wmv': return 'video/x-ms-wmv';
            case 'avi': return 'video/x-msvideo';
            case 'mkv': return 'video/x-matroska';
            case 'webm': return 'video/webm';

            // Archives
            case 'zip': return 'application/zip';
            case 'rar': return 'application/vnd.rar';
            case 'tar': return 'application/x-tar';
            case 'gz': return 'application/gzip';
            case '7z': return 'application/x-7z-compressed';

            // Code
            case 'html': return 'text/html';
            case 'css': return 'text/css';
            case 'js': return 'application/javascript';
            case 'json': return 'application/json';
            case 'xml': return 'application/xml';

            default: return 'application/octet-stream'; // fallback for unknown types
        }
    };
}